/*
 *  ************************************************************************
 *  *  © [2015 - 2020] Quintype Technologies India Private Limited
 *  *  All Rights Reserved.
 *  *************************************************************************
 */
import { MetypeCommentingWidget } from "@metype/components";
import PropTypes from "prop-types";
import get from "lodash/get";
import React from "react";
import { connect } from "react-redux";
import { isEmpty } from "../utils";
import { FacebookComment } from "./facebook-comment-widget.js";

function generateHostUrl(story = {}) {
  if (global.location) {
    return `${global.location.origin}/${story.slug}`;
  }
}

export class CommentingWidget extends React.Component {
  render() {
    const metypeConfig = get(this.props.pbConfig, ["general", "meType"], this.props.metype);
    const fbConfig = get(this.props.pbConfig, ["general", "commentType"], "");
    const story = get(this.props, ["story"], {});
    return (
      <>
        {isEmpty(metypeConfig) || !metypeConfig.accountId || !metypeConfig.host || fbConfig === "facebook" ? (
          <FacebookComment story={story} />
        ) : (
          <MetypeCommentingWidget
            host={metypeConfig.host}
            accountId={parseInt(metypeConfig.accountId)}
            pageURL={generateHostUrl(story)}
            primaryColor={metypeConfig.primaryColor}
          />
        )}
      </>
    );
  }
}

function mapStateToProps(state) {
  return {
    metype: get(state, ["qt", "config", "theme-attributes", "metype-config"], {}),
    pbConfig: get(state, ["qt", "config", "pagebuilder-config"], {})
  };
}

CommentingWidget.propTypes = {
  pbConfig: PropTypes.object,
  metype: PropTypes.object
};

export const CommentWidget = connect(mapStateToProps)(CommentingWidget);
